import { forwardRef } from "react"

interface CustomInputProps {
  value?: string
  onClick?: () => void
}

export const CustomInputForDatepicker = forwardRef<HTMLButtonElement, CustomInputProps>(({ value, onClick }, ref) => (
  <button
    color="blue"
    className="disabled:opacity-50 disabled:cursor-not-allowed !bg-white h-[42px] max-[767px]:h-[32px] border-1 rounded-lg w-full text-left pl-2.5 text-sm flex items-center border-gray-300"
    onClick={onClick}
    ref={ref}
  >
    {value || "Выберите дату"}
  </button>
))
